import { levelStep, MeterType, nextLevelFrom } from "@next-platform/packages-ts-types";
import { DefinitionLevelList } from "./meterDefinitionRows";
const getMeterFirstValue = (meter) => {
    if (meter.type === MeterType.BAR || meter.type === MeterType.PIPS) {
        return meter.min;
    }
    if (meter.type === MeterType.DICE) {
        return 1;
    }
    return 0;
};
const getDefinitionSegmentWeight = ({ meter, levels, level, index, step, }) => {
    const previousTo = index > 0 ? levels[index - 1]?.to : null;
    const firstFrom = getMeterFirstValue(meter);
    const from = previousTo === null || previousTo === undefined ? firstFrom : nextLevelFrom(meter, previousTo);
    const max = "max" in meter ? meter.max : undefined;
    return Math.max(step, (level.to ?? max ?? from) - from + step);
};
/** Relative widths of a definition level list's segments: value ranges by their span, other lists equally. */
const definitionSegmentWeights = ({ meter, levels, kind }) => {
    if (kind !== DefinitionLevelList.VALUE) {
        return levels.map(() => ({ weight: 1 }));
    }
    const step = meter.type === MeterType.NUMBER ? levelStep(meter) : 1;
    const max = "max" in meter ? meter.max : undefined;
    const boundedWeights = levels
        .map((level, index) => (level.to === null ? undefined : getDefinitionSegmentWeight({ meter, levels, level, index, step })))
        .filter((weight) => weight !== undefined);
    const openWeight = boundedWeights.length > 0 ? boundedWeights.reduce((total, weight) => total + weight, 0) / boundedWeights.length : 1;
    return levels.map((level, index) => ({
        weight: level.to === null && max === undefined ? openWeight : getDefinitionSegmentWeight({ meter, levels, level, index, step }),
    }));
};
export default definitionSegmentWeights;
